'use strict';

module.exports = function (ngModule) {
    ngModule.directive('laneGraph', require('./lanegraph'));
}


/** WEBPACK FOOTER **
 ** ./src/pages/directives/lanegraph/index.js
 **/